import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface ErrorLogFilters {
  requestId?: string;
  domain?: string;
  errorCode?: string;
  statusCode?: number | string;
  resolved?: boolean | string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

export const useGetErrorLogs = (filters: ErrorLogFilters = {}, enabled: boolean = true): QueryReturnType<any> => {
  // Build a stable query key from filters so react-query refetches when filters change
  return useQuery<never, never, any>(
    [ENDPOINTS.ERROR_LOGS, filters],
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 30 * 1000,        // 30 seconds — error logs should be fairly fresh
      cacheTime: 5 * 60 * 1000,
    }
  );
};
